// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 分页列表 GET /net_meeting/record/page_list */
export async function getNetMeetingRecordPageList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getNetMeetingRecordPageListParams,
  options?: { [key: string]: any },
) {
  return request<API.SPageC2ABNetMeetingMemberVoC2BB>('/net_meeting/record/page_list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
